import { atom } from 'recoil';

export const registerModalState = atom({
  key: 'registerTerms',
  default: false,
});